import { h, Host } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";
/**
 * UxTableBodyNeo - Experimental table body component
 * @slot - The rows of the table limited to <ux-table-row-neo>
 */
export class TableBodyNeo {
    host;
    /**
     * Emits the number of rows in the table
     * @internal
     */
    rowCountChange;
    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }
    /**
     * Handle slot change event
     */
    handleSlotChange(element) {
        if (!element) {
            return;
        }
        const nodes = element.assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.rowCountChange.emit(nodes.length);
    }
    render() {
        return (h(Host, { key: '43031bc15823ab369529082f9a8a43470d7f8e13', role: "rowgroup" }, h("slot", { key: '33d48405c8604aa57435dcb448e09d36fd662543', onSlotchange: (e) => this.handleSlotChange(e.target) })));
    }
    static get is() { return "ux-table-body-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-body-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-body-neo.css"]
        };
    }
    static get events() {
        return [{
                "method": "rowCountChange",
                "name": "rowCountChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": undefined
                        }],
                    "text": "Emits the number of rows in the table"
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=table-body-neo.js.map
